import {
  CAREPROVIDER_ACTIVE,
  COMPANY_TYPE_FACILITY,
  SEARCH_TYPE_CARE,
} from "core/consts";
import { Careprovider, DeepNullableObj } from "core/types";
import { defaultsDeep } from "lodash";
import { MockFn, createMock } from "./index";
import mockAccount from "./mockAccount";
import mockEvent from "./mockEvent";

const mockCareprovider: MockFn<Partial<DeepNullableObj<Careprovider>>> = (
  args,
): Careprovider =>
  defaultsDeep(
    args,
    createMock(
      "Careprovider",
      args,
      (shallow): DeepNullableObj<Careprovider> => ({
        __typename: "Careprovider",
        accounts: [mockAccount({ ...shallow("Account") })],
        activities: {
          invite_contacts_popup: false,
        },
        address: args?.address ?? {
          address: "Soldiner Str. 38",
          city: "Berlin",
          country: "DE",
          latitude: 52,
          longitude: 13,
          street: "Soldiner Str",
          street_number: "38",
          zip_code: "13359",
        },
        admission_forms: [],
        assignee: {
          __typename: "Account",
          first_name: null,
          id: null,
          last_name: null,
        },
        capacity: {
          available_date: null,
          decline_scope: null,
          has_capacity: null,
          updated_at: null,
        },
        central_email: null,
        central_phone_number: null,
        company: {
          companies: null,
          company_type: COMPANY_TYPE_FACILITY,
          force_id: null,
          id: null,
          ik_numbers: null,
          name: null,
          parent_company: null,
          status: null,
        },
        config: {
          disable_seald: false,
          seald_config: null,
          seald_only_encryption: true,
        },
        contacts: [],
        data_processing_agreement: null,
        duplicated_from: {
          __typename: "Careprovider",
          id: null,
          name: null,
          patient_type: SEARCH_TYPE_CARE,
        },
        email_requests: true,
        email_summary: false,
        events: mockEvent({ ...shallow("Event") }),
        extensions: [
          {
            __typename: "Extension",
            active_since: 1642620665,
            connected: true,
            integration_id: 1,
            integration_type: 2,
          },
        ],
        facilities: null,
        fax_number: null,
        feedback: null,
        files: { documents: [], images: [] },
        id: 1,
        inactive_reason: null,
        lead_id: null,
        metrics: {
          accept_count: null,
          attributed_count: null,
          avg_time_to_click: null,
          avg_time_to_open: null,
          avg_time_to_response: null,
          local_accept_count: null,
          local_attributed_count: null,
          local_maybe_count: null,
          local_request_count: null,
          local_response_count: null,
          maybe_count: null,
          request_count: null,
          response_count: null,
        },
        name: "Demo Pflege",
        new: false,
        no_capacities: [],
        onboarding: {
          call_back_date: null,
          comment: null,
          facility_size: null,
          information_system: null,
          information_system_other: null,
          new_facility_openings: null,
          responsible_person: null,
          status: null,
          waiting_list_usage: null,
        },
        onboarding_stats: {
          active_since: null,
          onboarding_source: null,
        },
        opportunity_id: null,
        other_remarks: null,
        patient_type: SEARCH_TYPE_CARE,
        pending_messages: null,
        ppm_receiver_id: null,
        prerequisites: null,
        product_features: [],
        profile: {
          accepted_age: { max: null, min: null },
          accepted_weight: { max: null, min: null },
          additional_costs: null,
          cardiovascular_equipment: null,
          caregiver_genders: null,
          confessions: null,
          digestive_endoscopy: null,
          imagery: null,
          languages: null,
          opt_out_b2c: false,
          other_technical_equipment: null,
          privacy_url: null,
          radius_in_meter: null,
          room_types: null,
          social_worker_on_site: null,
          supported_health_insurance_types: null,
          whitelisted_zipcodes: null,
        },
        provider_search_info: {
          eligible: null,
          state: null,
        },
        receive_fax: false,
        receive_sms: false,
        related_careseekers: [],
        seald_encryption_context: null,
        services: null,
        specializations: null,
        status: CAREPROVIDER_ACTIVE,
        terms_and_conditions: {
          date: null,
          version: null,
        },
        token: null,
        trigger_ppm_self_onboarding: false,
        website: null,
      }),
    ),
  );

export default mockCareprovider;
